import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AmbitosPaisesService {
  /**
   * @description Constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar ambito de paises
   * @params code
   */
  getEnvironmentCountry(code: string): Observable<ArrayBuffer> {
    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = { Paises: code };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.ambitosPaises.name,
      httpOpt
    ).pipe(
      map((e: any) => e.idAmbito)
    );

  }
}
